export default __webpack_public_path__ + "static/media/tn.742d5f88.jpg";